export default "__VITE_ASSET__d92ef071__"